module.exports = __webpack_public_path__ + "static/media/portfolio1 (24).b9624293.jpeg";